<section class="uploader-container mat-elevation-z4">
  <div class="header-band">
    <mat-toolbar color="primary">
      <span>CDN Image Uploader</span>
    </mat-toolbar>
  </div>

  <div class="uploader-content">
    <p class="uploader-hint">
      Drag and drop an image, or click to browse. It uploads straight to the CDN — copy the
      link below and paste it wherever you need an image in the app.
    </p>

    <div
      class="drop-zone"
      [class.dragging]="isDragging"
      (click)="fileInput.click()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <input #fileInput type="file" hidden accept="image/*" (change)="onFileInput($event)" />

      @if (isUploading) {
        <mat-spinner diameter="40" />
        <span>Uploading…</span>
      } @else if (preview) {
        <img [src]="preview" alt="Preview" class="image-preview" />
      } @else {
        <mat-icon>cloud_upload</mat-icon>
        <span>Drop an image here, or click to browse</span>
        <span class="drop-zone-subtext">PNG, JPG, WEBP, GIF, SVG — up to 10MB</span>
      }
    </div>

    @if (errorMessage) {
      <p class="error-message">{{ errorMessage }}</p>
    }

    @if (cdnUrl) {
      <div class="result-box">
        <mat-icon class="result-icon">check_circle</mat-icon>
        <input type="text" readonly [value]="cdnUrl" class="cdn-url-input" />
        <button mat-flat-button color="primary" type="button" (click)="copyLink()">
          {{ copied ? "Copied!" : "Copy link" }}
        </button>
      </div>
      <button mat-stroked-button type="button" class="upload-another-btn" (click)="reset()">
        Upload another image
      </button>
    }
  </div>
</section>

<section class="uploader-container mat-elevation-z4 gallery-section">
  <div class="header-band">
    <mat-toolbar color="primary">
      <span>Uploaded Images</span>
    </mat-toolbar>
  </div>

  <div class="uploader-content">
    @if (isLoadingImages) {
      <div class="gallery-loading">
        <mat-spinner diameter="32" />
      </div>
    } @else if (images.length === 0) {
      <p class="uploader-hint">No images uploaded through this tool yet.</p>
    } @else {
      <div class="gallery-grid">
        @for (image of images; track image.key) {
          <div class="gallery-item">
            <img [src]="image.url" [alt]="image.key" class="gallery-thumb" />
            <div class="gallery-meta">
              <span class="gallery-size">{{ formatSize(image.size) }}</span>
              <div class="gallery-actions">
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'Copy link'"
                  [title]="copiedKey === image.key ? 'Copied!' : 'Copy link'"
                  (click)="copyImageLink(image)"
                >
                  <mat-icon>{{ copiedKey === image.key ? "check" : "content_copy" }}</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  color="warn"
                  aria-label="Delete image"
                  title="Delete"
                  [disabled]="deletingKey === image.key"
                  (click)="deleteImage(image)"
                >
                  @if (deletingKey === image.key) {
                    <mat-spinner diameter="18" />
                  } @else {
                    <mat-icon>delete</mat-icon>
                  }
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
